import {PreloaderOptions} from 'neo-common';

export type AppBaseOptionsType = {
    preloaderOptions: PreloaderOptions;
    gameDefinition: {
        file: string;
    };
    gameConfiguration: {
        file: string;
    };
    clientHost: {
        defaultClientHostType: string;
    }
}

/**
 * @enum AppLoadStatus - status of application loading process.
 */
export enum AppLoadStatus {
    Unknown,
    Loading,
    Success,
    Failure
}

/**
 * @type AppLoadResult - result of App.load().
 */
export type AppLoadResult = {
    status: AppLoadStatus;
    error: Error;
}

/**
 * Game quality size type
 */
export type GameQualitySize = {
    width: number;
    height: number;
}

/**
 * Object for holding dictionary of quality sizes
 */
export type GameQualities = { [key: string]: GameQualitySize };

export interface IGameConfigurationProxy {
    getValue<T>(key: string, defaultValue: T): T;
    setValue<T>(key: string, value: T): void;
}


/** WEBPACK FOOTER **
 ** ./Engine/GameEngine/Types.ts
 **/